var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3879_90120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7402 20.2402C41.0445 20.2402 40.4805 20.8043 40.4805 21.5C40.4805 31.9659 31.9659 40.4805 21.5 40.4805C11.0341 40.4805 2.51953 31.9659 2.51953 21.5C2.51953 11.0341 11.0341 2.51953 21.5 2.51953C25.7142 2.51953 29.718 3.88478 33.0085 6.40406L30.8221 6.79039C30.137 6.91141 29.6797 7.56498 29.8008 8.25012C29.9218 8.93527 30.5753 9.39256 31.2605 9.27145L36.0311 8.4285C36.633 8.32218 37.0717 7.79912 37.0717 7.18797V2.41732C37.0717 1.7216 36.5077 1.15756 35.8119 1.15756C35.1162 1.15756 34.5522 1.7216 34.5522 2.41732V4.41246C30.8218 1.55094 26.2804 0 21.5 0C15.7571 0 10.358 2.23642 6.29715 6.29715C2.23642 10.358 0 15.7571 0 21.5C0 27.2429 2.23642 32.642 6.29715 36.7029C10.358 40.7636 15.7571 43 21.5 43C27.2429 43 32.642 40.7636 36.7029 36.7029C40.7636 32.642 43 27.2429 43 21.5C43 20.8043 42.436 20.2402 41.7402 20.2402Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2188 16.4609V14.3613C28.2188 10.6566 25.2047 7.64258 21.5 7.64258C17.7953 7.64258 14.7812 10.6566 14.7812 14.3613V16.4609H17.3008V14.3613C17.3008 12.0459 19.1846 10.1621 21.5 10.1621C23.8154 10.1621 25.6992 12.0459 25.6992 14.3613V16.4609H28.2188Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6816 20.2402V30.7383C12.6816 31.434 13.2457 31.998 13.9414 31.998H29.0586C29.7543 31.998 30.3184 31.434 30.3184 30.7383V20.2402C30.3184 19.5445 29.7543 18.9805 29.0586 18.9805H13.9414C13.2457 18.9805 12.6816 19.5445 12.6816 20.2402ZM20.6602 23.5996H22.3398C23.0356 23.5996 23.5996 24.1636 23.5996 24.8594C23.5996 25.5551 23.0356 26.1191 22.3398 26.1191H20.6602C19.9644 26.1191 19.4004 25.5551 19.4004 24.8594C19.4004 24.1636 19.9644 23.5996 20.6602 23.5996Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3879_90120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.4c2c7dc463691cbf61ae3df26e2ed73e.svg";
export { ForwardRef as ReactComponent };